module.exports = __webpack_public_path__ + "de3e821f88dba4410641c73f63fde521.txt";